import styled from 'styled-components';

export default styled.label`
  padding-left: 15px;
  font-size: 12px;
  line-height: 22px;
  color: #232734;
  margin: 0;
`;
